module.exports = __webpack_public_path__ + "static/media/search.44bbab5e.svg";